import SelectRecordPlay from "../../components/RecordingFeatures/SelectRecordPlay";
import "../../css/app/recordingDetail.css";

const MyRecording = ({startRecording, elapsedTime}) => {

    return (
        <div className="vr-rd-page">
            <div className="row">
                <div className="col- col-sm-12 col-md-12 col-lg-12">
                    <SelectRecordPlay  startRecording={startRecording} elapsedTime={elapsedTime} />
                </div>
            </div>
        </div>
    );
};

export default MyRecording;
